import React, { createContext, useContext, useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { getResultOrigin } from 'dataProvider';
import { useContextMatchParams } from 'contexts/matchParams';
import { TYPES } from 'envs';

const ResultOriginContext = createContext();

export const ResultOriginProvider = ({ children }) => {
  const [resultOrigin, setResultOrigin] = useState({});
  const { matchParams } = useContextMatchParams();

  const { year, type, electionNumber, placeId, community, placesId } =
    matchParams;

  let finalPlaceId = placeId;

  if (type === TYPES.REGIONAL && !placeId) {
    if (placesId) {
      [finalPlaceId] = placesId.split('-');
    } else {
      finalPlaceId = community;
    }
  }

  useEffect(() => {
    getResultOrigin(year, type, electionNumber, finalPlaceId)
      .then(historicResult => {
        setResultOrigin(historicResult);
      })
      .catch(err => {
        console.log(err);
      });
  }, [electionNumber, finalPlaceId, type, year]);
  if (!resultOrigin?.primary) {
    return null;
  }
  return (
    <ResultOriginContext.Provider value={resultOrigin}>
      {children}
    </ResultOriginContext.Provider>
  );
};

export const useContextResultOrigin = () => useContext(ResultOriginContext);

ResultOriginProvider.propTypes = {
  matchParams: PropTypes.shape({
    year: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    electionNumber: PropTypes.string.isRequired,
    placeId: PropTypes.string.isRequired
  }).isRequired,
  children: PropTypes.node.isRequired
};
